import React from 'react';
import { connect } from 'react-redux';

import axios from 'axios';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Modal } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';

import { obterFormandosPeloContrato } from '../actions/FormandoActions';
import { editarCamposContrato } from '../actions/ContratoActions';
import MapaServices from '../services/mapa';
import { colunaDaMesmaPeca, ehPecaVendida } from '../services/mesmaPeca';
import { colunasComCompra, comprasDoFormando } from '../services/pedidosComprados';
import { URL_PAGAMENTO } from '../config/urls';

// Exportada tambem sem o connect, para os testes.
export class DetalhesDistribuicao extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showModal: false,
      tabelaItens: false,
      itensTabela: {
        headerComprado: [],
        body: [],
        totalComprado: []
      },
      selecionado: {},
      carregandoChangeEtapa: false,
      pedidos: []
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  open () {
    this.setState({ showModal: true, tabelaItens: false, itensTabela: { headerComprado: [], body: [], totalComprado: [] }, selecionado: this.props.selecionado }, () => {
      this.carregarInfoContrato(this.state.selecionado.id);
    });
  }

  close () {
    this.props.atualizarContrato({
      id: this.state.selecionado.id,
      distribuiuItens: this.state.selecionado.distribuiuItens
    });
    this.setState({ showModal: false });
  }

  async carregarInfoContrato(idContrato) {
    let pedidos = [];
    await axios.get(`${URL_PAGAMENTO}/administracao/pedidos-contrato/${idContrato}`, {
      headers: { "Authorization": "Bearer " + localStorage.getItem("tokenPagamento") }
    }).then((response) => {
      pedidos = response.data;
    }).catch(() => {
      toast.error("Não foi possível consultar os pagamentos deste contrato!");
    });

    this.props.obterFormandosPeloContrato(idContrato).then(async () => {
      const { headerComprado, possuiAlphaPlay } = await this.montarHeaders();
      const { body, totalComprado } = this.montarBody(headerComprado, pedidos);

      // Peca avulsa que so tem pedido nao pago nao vira coluna.
      const ficam = colunasComCompra(headerComprado, totalComprado, this.state.selecionado.itens);
      const soAsQueFicam = (lista) => lista.filter((valor, j) => ficam[j]);
      body.forEach((turma) => {
        turma.subtotalComprado = soAsQueFicam(turma.subtotalComprado);
        turma.formandos.forEach((formando) => { formando.colsComprado = soAsQueFicam(formando.colsComprado); });
      });

      this.setState({
        pedidos,
        possuiAlphaPlay,
        itensTabela: { headerComprado: soAsQueFicam(headerComprado), body, totalComprado: soAsQueFicam(totalComprado) },
        tabelaItens: true
      });
    });
  }

  abreviar(nome) {
    return nome
      .replace("Convite ", "")
      .replace(" com ", " c/ ")
      .replace(" sem ", " s/ ")
      .replace("Aproveitamento", "Aprov.");
  }

  // `original` guarda o nome do contrato: `produto` vai abreviado para a
  // tela, e e pelo nome inteiro que a peca avulsa acha a coluna dela.
  adicionarHeaderLocal(header, nome, id, original) {
    id = Number(id);
    const itemPesquisado = header.find((i) => i.produto === nome);
    if (!itemPesquisado) {
      header.push({ produto: nome, original: original || nome, ids: [id] });
    } else {
      itemPesquisado.ids.push(id);
    }
  }

  // A descricao do produto da coluna, quando ela e de um item so (nao de um
  // componente de kit): ajuda a achar o formato que o nome nao traz.
  descricaoDaColuna(coluna, itens) {
    const doItem = (coluna.ids || [])
      // eslint-disable-next-line eqeqeq
      .map((id) => itens.find((item) => item.id == id))
      .filter((item) => item && item.observacao !== "kit");

    return doItem.length === 1 ? doItem[0].descricao : null;
  }

  async montarHeaders() {
    const mapa = new MapaServices();
    const itens = this.state.selecionado.itens;
    let headerComprado = [];
    let possuiAlphaPlay = null;

    await mapa.possuiAlphaPlay(this.state.selecionado.numOrcamento).then((response) => {
      if (response.length > 0) possuiAlphaPlay = `Este contrato possui Alpha-Play!`;
    }).catch(() => { toast.error("Não foi possível se comunicar com o Mapa de Vendas. Tente novamente!"); });

    const pecas = [];

    for (let i = 0; i < itens.length; i++) {
      const item = itens[i];

      // As pecas vendidas avulsas entram depois, quando as colunas dos
      // produtos ja existem: ai da para ver se a peca e a mesma de um deles.
      if (ehPecaVendida(item)) {
        pecas.push(item);
        continue;
      }

      // Brindes somam na mesma coluna do produto (não há mais coluna separada).
      // Reaproveita a coluna existente pelo nome ou cria uma nova.
      if (item.observacao === "brinde") {
        this.adicionarHeaderLocal(headerComprado, this.abreviar(item.produto), item.id, item.produto);
      } else if (item.observacao === "kit") {
        const auxItens = item.itens ? item.itens.split(";") : [];
        for (let j = 0; j < auxItens.length; j++) {
          if (auxItens[j] !== "") {
            const nomeOriginal = auxItens[j].substring(auxItens[j].split(" ")[0].length + 1);
            this.adicionarHeaderLocal(headerComprado, this.abreviar(nomeOriginal), item.id, nomeOriginal);
          }
        }
      } else {
        this.adicionarHeaderLocal(headerComprado, this.abreviar(item.produto), item.id, item.produto);
      }
    }

    // A peca que e a mesma de um produto do contrato (mesmo nome e formato)
    // soma na coluna dele; as demais ganham coluna propria.
    const colunas = headerComprado.map((coluna) => ({
      nome: coluna.original || coluna.produto,
      descricao: this.descricaoDaColuna(coluna, itens),
    }));

    pecas.forEach((peca) => {
      const j = colunaDaMesmaPeca(peca, colunas);

      if (j > -1) {
        headerComprado[j].ids.push(Number(peca.id));
      } else {
        this.adicionarHeaderLocal(headerComprado, this.abreviar(peca.produto), peca.id, peca.produto);
      }
    });

    // Inserir colunas de total de miolos no grupo Comprado
    headerComprado = this.inserirTotaisMiolos(headerComprado);

    return { headerComprado, possuiAlphaPlay };
  }

  inserirTotaisMiolos(header) {
    let auxHeader = [], temLuxo = 0, temSemi = 0, temSimples = 0;

    header.forEach(item => {
      if (item.produto.includes("Luxo") && !item.produto.includes("Semi-")) { auxHeader.push(item); temLuxo++; }
    });
    if (temLuxo >= 2) auxHeader.push({ produto: "TOTAL MIOLOS LUXO", ids: [], isTotalMiolo: true });

    header.forEach(item => {
      if (item.produto.includes("Semi-")) { auxHeader.push(item); temSemi++; }
    });
    if (temSemi >= 2) auxHeader.push({ produto: "TOTAL MIOLOS SEMI-LUXO", ids: [], isTotalMiolo: true });

    header.forEach(item => {
      if (item.produto.includes("Simples")) { auxHeader.push(item); temSimples++; }
    });
    if (temSimples >= 2) auxHeader.push({ produto: "TOTAL MIOLOS SIMPLES", ids: [], isTotalMiolo: true });

    header.forEach(item => {
      if (!item.produto.includes("Luxo") && !item.produto.includes("Semi-") && !item.produto.includes("Simples")) {
        auxHeader.push(item);
      }
    });

    return auxHeader;
  }

  montarBody(headerComprado, pedidos) {
    const { formandos } = this.props;
    const { itens, turmas } = this.state.selecionado;
    let indexFormandos = 0;
    const totalComprado = headerComprado.map(() => 0);

    const totalLuxoIdx = headerComprado.map(i => i.produto).indexOf("TOTAL MIOLOS LUXO");
    const totalSemiIdx = headerComprado.map(i => i.produto).indexOf("TOTAL MIOLOS SEMI-LUXO");
    const totalSimplesIdx = headerComprado.map(i => i.produto).indexOf("TOTAL MIOLOS SIMPLES");

    // Itens do contrato que a comissao distribuiu (so no rateio)
    const rateio = String(this.state.selecionado.pagamentoIndividual) === "false";
    const itensDistribuidos = {};
    if (rateio) {
      formandos.forEach((formando) => {
        formando.itens.forEach((itemFormando) => {
          if (itemFormando.tipo === "contratado" && Number(itemFormando.quantidade) > 0) {
            itensDistribuidos[itemFormando.item] = true;
          }
        });
      });
    }

    // Soma `quantidade` do item do contrato na linha do formando: o kit abre
    // nas pecas dele; convite soma tambem no total de miolos.
    const somarItem = (formando, itemPesquisado, quantidade) => {
      if (itemPesquisado.observacao === "kit") {
        const subItens = itemPesquisado.itens ? itemPesquisado.itens.split(";") : [];
        subItens.forEach((itemStr) => {
          if (itemStr === "") return;
          const itemQuantidade = Number(itemStr.split(" ")[0]);
          const nomeOriginal = itemStr.substring(itemStr.split(" ")[0].length + 1);
          const nomeAbrev = this.abreviar(nomeOriginal);
          const qtd = quantidade * itemQuantidade;

          // total miolos — baseado no nome abreviado que está no header
          {
            let idx = -1;
            if (nomeAbrev.includes("Semi-")) idx = totalSemiIdx;
            else if (nomeAbrev.includes("Luxo")) idx = totalLuxoIdx;
            else if (nomeAbrev.includes("Simples")) idx = totalSimplesIdx;
            if (idx !== -1) { formando.colsComprado[idx] += qtd; totalComprado[idx] += qtd; }
          }

          headerComprado.forEach((col, j) => {
            if (!col.isTotalMiolo && col.produto === nomeAbrev) {
              formando.colsComprado[j] += qtd;
              totalComprado[j] += qtd;
            }
          });
        });
      } else {
        const qtd = quantidade;
        const nomeAbrev = this.abreviar(itemPesquisado.produto);
        headerComprado.forEach((col, j) => {
          // eslint-disable-next-line eqeqeq
          if (col.ids.some((id) => id == itemPesquisado.id)) {
            formando.colsComprado[j] += qtd;
            totalComprado[j] += qtd;
          }
        });
        {
          let idx = -1;
          if (nomeAbrev.includes("Semi-")) idx = totalSemiIdx;
          else if (nomeAbrev.includes("Luxo")) idx = totalLuxoIdx;
          else if (nomeAbrev.includes("Simples")) idx = totalSimplesIdx;
          if (idx !== -1) { formando.colsComprado[idx] += qtd; totalComprado[idx] += qtd; }
        }
      }
    };

    formandos.forEach((formando) => {
      formando.colsComprado = headerComprado.map(() => 0);

      // --- Brindes --- somam na mesma coluna do produto (pelo id do item).
      formando.itens.forEach((itemFormando) => {
        if (itemFormando.tipo !== "brinde") return;
        // eslint-disable-next-line eqeqeq
        const itemPesquisado = itens.find((i) => i.id == itemFormando.item);
        if (!itemPesquisado || itemPesquisado.observacao !== "brinde") return;
        const qtd = Number(itemFormando.quantidade);
        const nomeAbrev = this.abreviar(itemPesquisado.produto);
        headerComprado.forEach((col, j) => {
          if (!col.isTotalMiolo && col.ids.some((id) => id == itemPesquisado.id)) {
            formando.colsComprado[j] += qtd;
            totalComprado[j] += qtd;
          }
        });
        // soma também no total de miolos correspondente, se aplicável
        let idx = -1;
        if (nomeAbrev.includes("Semi-")) idx = totalSemiIdx;
        else if (nomeAbrev.includes("Luxo")) idx = totalLuxoIdx;
        else if (nomeAbrev.includes("Simples")) idx = totalSimplesIdx;
        if (idx !== -1) { formando.colsComprado[idx] += qtd; totalComprado[idx] += qtd; }
      });

      // --- Distribuicao da comissao (rateio) ---
      // Contrato sem pagamento individual: a comissao paga e reparte os itens
      // do contrato entre os formandos no portal (itemFormando "contratado").
      // A quantidade de cada um e essa distribuicao.
      if (rateio) {
        formando.itens.forEach((itemFormando) => {
          if (itemFormando.tipo !== "contratado") return;
          // eslint-disable-next-line eqeqeq
          const itemPesquisado = itens.find((i) => i.id == itemFormando.item);
          if (!itemPesquisado || itemPesquisado.observacao === "brinde") return;
          somarItem(formando, itemPesquisado, Number(itemFormando.quantidade) || 0);
        });
      }

      // --- Comprado (pedidos) ---
      // So os pedidos pagos sao compra: pendente e cancelado ficam de fora.
      const pedidosValidos = comprasDoFormando(pedidos.find(p => p.id === formando.id));

      pedidosValidos.forEach((pedido) => {
        if (!pedido.itens) return;
        pedido.itens.forEach((itemPedido) => {
          // eslint-disable-next-line eqeqeq
          const itemPesquisado = itens.find((i) => i.id == itemPedido.itemContrato);
          if (!itemPesquisado || itemPesquisado.observacao === "brinde") return;
          // No rateio, o pedido de um item distribuido so paga o excedente,
          // que ja esta na distribuicao.
          if (itensDistribuidos[itemPesquisado.id]) return;
          somarItem(formando, itemPesquisado, itemPedido.quantidade);
        });
      });
    });

    turmas.forEach((turma) => {
      turma.formandos = formandos.filter((f) => f.turma === turma.id);
      turma.indexFormandos = indexFormandos;
      indexFormandos += turma.formandos.length;
      turma.subtotalComprado = headerComprado.map(() => 0);
      turma.formandos.forEach((formando) => {
        formando.colsComprado.forEach((v, k) => { turma.subtotalComprado[k] += v; });
      });
    });

    return { body: turmas, totalComprado };
  }

  changeEtapa = (valor) => {
    this.setState({ carregandoChangeEtapa: true });
    this.props.editarCamposContrato( this.state.selecionado.id, { distribuiuItens: valor }).then(() => {
      this.setState({ selecionado: { ...this.state.selecionado, distribuiuItens: valor }, carregandoChangeEtapa: false});
    });
  }

  _renderCadeado () {
    let distribuiuItens = this.state.selecionado && this.state.selecionado.distribuiuItens === 1 ? true : false,
      novoValor = distribuiuItens ? 0 : 1;
    return <i disabled={this.state.carregandoChangeEtapa} className={this.state.carregandoChangeEtapa ? "fa fa-spinner fa-spin" : distribuiuItens ? "fa fa-lock" : "fa fa-unlock"} onClick={() => this.changeEtapa(novoValor)}/>;
  }

  render() {
    const { itensTabela, tabelaItens, selecionado, possuiAlphaPlay } = this.state;
    const hC = tabelaItens ? itensTabela.headerComprado : [];
    const totalCols = 2 + hC.length;

    return (
      <Modal show={this.state.showModal} onHide={this.close} bsSize="large">
        <ToastContainer/>
        <Modal.Header closeButton>
          <Modal.Title>{this._renderCadeado()} | Planilha de quantidades do contrato {selecionado ? selecionado.numero : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            tabelaItens && selecionado.distribuiuItens ?
              <div style={{ marginBottom: 15, height: 500, overflow: "auto" }}>
                <table className="table" id="tabelaDistribuicao">
                  <thead>
                    <tr>
                      <th style={{textAlign:"center", border: "1px solid black", fontSize: 16}} colSpan={totalCols}>
                        Lista de quantidades - <span style={{textDecoration: "underline", textTransform: "uppercase"}}>Contrato {selecionado.numero}</span>
                      </th>
                    </tr>
                    <tr><td style={{border: "0 none"}}></td></tr>
                    { possuiAlphaPlay ? <tr><td colSpan={totalCols} style={{backgroundColor: "green", color: "white", textAlign: "center", fontSize: 16}}><strong>Alpha-Play: {possuiAlphaPlay}</strong></td></tr> : null }
                    <tr><td style={{border: "0 none"}}></td></tr>
                    <tr>
                      <th style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>X</th>
                      <th style={{border: "1px solid black", fontSize: 16}}>Formando</th>
                      { hC.map((col, i) => <th key={`hc${i}`} style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>{col.produto}</th>) }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      itensTabela.body.map((turma, i) => [
                        <tr key={`turma${i}`}>
                          <td></td>
                          <td style={{color: "red", textTransform: "uppercase", fontSize: 10, fontWeight: "bolder", textAlign: "center"}}>{turma.curso}</td>
                          <td colSpan={totalCols - 2}></td>
                        </tr>,
                        turma.formandos.map((formando, j) => (
                          <tr key={`f${formando.id}`}>
                            <td style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>{turma.indexFormandos + j + 1}</td>
                            <td style={{border: "1px solid black"}}>{formando.nome}</td>
                            { formando.colsComprado.map((v, k) => <td key={`cc${k}`} style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>{v}</td>) }
                          </tr>
                        )),
                        <tr key={`esp${i}`}><td style={{border: "0 none"}}></td></tr>,
                        <tr key={`sub${i}`}>
                          <td style={{border: "1px solid black", borderRightColor: "transparent"}}></td>
                          <td style={{border: "1px solid black", borderLeftColor: "transparent", textAlign: "center"}}>Subtotal da turma de {turma.curso}</td>
                          { turma.subtotalComprado.map((v, k) => <td key={`sc${k}`} style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>{v}</td>) }
                        </tr>,
                        <tr key={`esp2${i}`}><td style={{border: "0 none"}}></td></tr>
                      ])
                    }
                    <tr>
                      <td style={{border: "1px solid black", borderRightColor: "transparent"}}></td>
                      <td style={{border: "1px solid black", borderLeftColor: "transparent", textAlign: "center", fontSize: 16, fontWeight: 600}}>TOTAL</td>
                      { itensTabela.totalComprado.map((v, i) => <td key={`gtc${i}`} style={{border: "1px solid black", textAlign: "center", fontSize: 16, fontWeight: 600}}>{v}</td>) }
                    </tr>
                    <tr><td style={{border: "0 none"}}></td></tr>
                    <tr><td style={{border: "0 none"}}></td></tr>
                    <tr><td style={{border: "0 none"}}></td></tr>
                    {/* INFORMAÇÕES PARA FATURAMENTO E ENTREGA */}
                    <tr><td colSpan={totalCols} style={{border: "1px solid black", textAlign: "center", fontSize: 16}}><strong>Informações para faturamento e entrega</strong></td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Responsável</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.nome : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>CPF</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.cpf : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>RG</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.rg : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>E-mail</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.email : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Celular</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.celular : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Endereço</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? `${selecionado.endereco.rua}, ${selecionado.endereco.numero}${selecionado.endereco.complemento ? ` - ${selecionado.endereco.complemento}` : ''}` : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Bairro</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.bairro : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Cidade</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.cidade : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Estado</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.estado : "Não preenchido"}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>CEP</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={totalCols - 1}>{selecionado.endereco ? selecionado.endereco.cep : "Não preenchido"}</td></tr>
                  </tbody>
                </table>
                <ReactHTMLTableToExcel
                  className="btn btn-success pull-right"
                  table="tabelaDistribuicao"
                  filename={`Lista de quantidades - ${selecionado.numero}`}
                  sheet={`Lista de quantidades - ${selecionado.numero}`}
                  buttonText="Baixar"
                />
              </div>
            : <h4>Esta etapa ainda não foi finalizada</h4>
          }
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    formandos: state.formando.todos
  }
}

export default connect(mapStateToProps, { editarCamposContrato, obterFormandosPeloContrato }, null, { forwardRef: true }) (DetalhesDistribuicao);


// WEBPACK FOOTER //
// ./src/components/DetalhesDistribuicao.js